namespace distill.artifacts.views.index {

    export interface InitArgs {
        dataTableUrl: string;
        folderId?: string;
        uploadUrl: string;
        moveItemUrl: string;
        createFolderUrl: string;
        getIconListUrl: string;
        inlineUpdateUrl: string;
        inlineTrashUrl: string;
        fromDocDefinitionUrl: string;
        canEdit: boolean;
    }

    interface UploadItem {
        file: File;
        path: string;
    }

    let _initArgs: InitArgs;
    let _dataTable: any;
    let _currentFolderId: string | null = null;

    export function init(args: InitArgs) {
        _initArgs = args;
        const params = new URLSearchParams(window.location.search);
        _currentFolderId = params.get('folderId');

        createDataTable();
        addEvents();
        addNavigationEvents();
        setupDragAndDrop();

        if ($('#hiddenSingleTrashBtn').length > 0) {
            appn.trash.addTrashMessage($('#hiddenSingleTrashBtn'), '#singleTrashItemName');
        }

        if (_currentFolderId) {
            refreshBreadcrumbs(_currentFolderId);
            refreshActionButtons(_currentFolderId);
        } else {
            $('.main-header h2.navbar-text').text(T('Artifacts'));
            $('.nav-back-button').hide();
        }

        window.addEventListener('popstate', handlePopState);
    }

    function addEvents() {
        if (!_initArgs.canEdit) return;

        $('#manageBtn').on('click', function (e: Event) {
            appn.dialog.showLoading();
        });

        $('#addFolderBtn').off('click').on('click', function (e) {
            e.preventDefault();
            const currentParentId = _initArgs.folderId || '';
            const basePath = _initArgs.dataTableUrl.split('?')[0].replace('/DataTable', '');
            const createUrl = `${basePath}/Create?parentId=${currentParentId}`;

            appn.iframe.openModal({
                url: createUrl,
                title: T('Folder')
            });
        });

        $('#uploadFileBtn').click(function (e) {
            e.preventDefault();
            $('#global-file-input').trigger('click');
        });

        $('#uploadFolderBtn').click(function (e) {
            e.preventDefault();
            $('#global-folder-input').trigger('click');
        });

        $('#global-folder-input').on('change', (e: any) => {
            if (e.target.files && e.target.files.length > 0) {
                uploadFiles(convertFileListToItems(e.target.files));
            }
        });

        $('#fromFilesDocsBtn').on('click', function(e) {
            e.preventDefault();
            const currentFolderId = _initArgs.folderId || '';
            const createUrl = `${_initArgs.fromDocDefinitionUrl}?folderId=${currentFolderId}`;

            appn.iframe.openModal({
                url: createUrl,
                title: T('From Files & Docs')
            });
        });
    }

    function addNavigationEvents() {
        $('body').on('click', '.breadcrumb a, a[data-folder-link], a[data-nav="folder"], .nav-back-button', function(e) {
            const $this = $(this);

            let folderId = $this.attr('data-folder-id');
            if (typeof folderId === 'undefined')
                folderId = $this.attr('data-folder');

            if ($this.hasClass('nav-back-button')) {
                const href = $this.attr("href");
                const params = new URLSearchParams(href?.split('?')[1]);
                const parentFolderId = params.get('folderId');
                if (parentFolderId){
                    e.preventDefault();
                    e.stopPropagation();
                    navigateToFolder(parentFolderId || null);
                }
                return;
            }

            if ($this.data('nav') === 'folder') {
                e.preventDefault();
                navigateToFolder(folderId || null);
                return;
            }

            if (typeof folderId !== 'undefined') {
                e.preventDefault();
                navigateToFolder(folderId || null);
            }
        });
    }

    function navigateToFolder(folderId: string | null) {
        if (folderId === _currentFolderId)
            return;

        _currentFolderId = folderId;
        _initArgs.folderId = folderId || '';

        const basePath = _initArgs.dataTableUrl.split('?')[0].replace('/DataTable', '');

        history.pushState({ folderId: folderId }, "", folderId ? `${basePath}?folderId=${folderId}` : basePath);

        refreshDataTable();
        refreshBreadcrumbs(folderId);
        refreshActionButtons(folderId);
    }

    function handlePopState(event: PopStateEvent) {
        const folderId = event.state?.folderId ?? null;
        _currentFolderId = folderId;
        _initArgs.folderId = folderId || '';

        refreshDataTable();
        refreshBreadcrumbs(folderId);
        refreshActionButtons(folderId);
    }

    export function refreshDataTable() {
        if (!_dataTable)
            return;

        $(_dataTable.fnSettings().nTableWrapper).removeClass('d-none');
        _dataTable.fnDraw(true);
    }

    function refreshBreadcrumbs(folderId: string | null) {
        const basePath = _initArgs.dataTableUrl.split('?')[0].replace('/DataTable', '');
        const breadcrumbsUrl = `${basePath}/GetBreadcrumbs?folderId=${folderId || ''}`;

        appn.ajax.get({
            url: breadcrumbsUrl,
            done: function(data: any) {
                if (!data || !data.success) {
                    console.error("Server reported error:", data?.message);
                    return;
                }

                if (data.currentName)
                    $('.main-header h2.navbar-text').text(`${T('Artifacts')} > ${data.currentName}`);
                else
                    $('.main-header h2.navbar-text').text(T('Artifacts'));

                const $breadcrumb = $('.dt-action-title .breadcrumb');
                let html = `<li class="breadcrumb-item drop-target" data-id=""><a href="${basePath}" data-folder-id=""><i class="fa fa-home"></i></a></li>`;

                if (data.breadcrumbs && Array.isArray(data.breadcrumbs)) {
                    data.breadcrumbs.forEach(function(crumb: any) {
                        html += `<li class="breadcrumb-item drop-target" data-id="${crumb.Id}"><a href="${basePath}?folderId=${crumb.Id}" data-folder-id="${crumb.Id}">${crumb.Name}</a></li>`;
                    });

                    $('.nav-back-button').attr("href", data.breadcrumbs.length > 0
                        ? `${basePath}?folderId=${data.breadcrumbs[data.breadcrumbs.length - 1].Id}` : basePath)
                }

                if (data.currentName && folderId)
                    html += `<li class="breadcrumb-item active font-weight-bold" aria-current="page">${data.currentName}</li>`;

                $breadcrumb.html(html);
            },
            fail: function() {
                console.error("Failed to load breadcrumbs");
            }
        });
    }

    function refreshActionButtons(folderId: string | null) {
        if (folderId)
            $('.nav-back-button').show();
        else
            $('.nav-back-button').hide();

        $('#manageBtn').attr('data-folder-id', folderId || '');
    }

    function convertFileListToItems(files: FileList) {
        const items: UploadItem[] = [];
        for (let i = 0; i < files.length; i++) {
            items.push({
                file: files[i],
                path: files[i].webkitRelativePath || files[i].name
            });
        }
        return items;
    }

    function createDataTable() {
        _dataTable = appn.dataTable.create('.dataTable', {
            sAjaxSource: _initArgs.dataTableUrl,
            fnServerData: function (aoData: any) {
                if (_initArgs.folderId && _initArgs.folderId !== appn.emptyGuid) {
                    aoData.push({ "name": "folderId", "value": _initArgs.folderId });
                }
            },
            autoWidth: false,
            aaSorting: [[2, 'asc'], [1, 'asc']],
            aoColumns: [
                { bSortable: false, sWidth: '3%' },
                { bSortable: true, sWidth: '25%' },
                { bSortable: true, sWidth: '8%' },
                { bSortable: true, sWidth: '12%' },
                { bSortable: true, sWidth: '10%' },
                { bSortable: true, sWidth: '22%' },
                { bSortable: true, sWidth: '10%' },
                { bSortable: true, sWidth: '10%' },
                { bSortable: false, sWidth: '5%' }
            ],
            createdRow: function (nRow: Node) {
                const $meta = $(nRow).find('.item-meta');
                if ($meta.length) {
                    const isFolder = $meta.data('is-folder');
                    $(nRow).addClass('draggable-row')
                        .attr('draggable', 'true')
                        .attr('data-id', $meta.data('id'))
                        .attr('data-is-folder', isFolder);

                    if (isFolder) {
                        $(nRow).addClass('drop-target');
                    }
                }
            },
            fnInitComplete: function () {
                appn.actionButtons.renderNavbarActionButtons([
                    { buttonId: 'manageBtn', buttonType: 'Manage', isDataTableToggleBtn: true }
                ], appn.requestUser.isUserOrHigher, true);

                $('.dataTables_controls_start').append($('.dt-action-title'));

                $('#manageBtn').on('click', function (this: HTMLElement, e: any) {
                    e.preventDefault();
                    if ($(this).css('opacity') === '1') {
                        const selectedItems = $('.selectRow:checked');

                        let items = appn.emptyString;
                        selectedItems.each(function (index: number, selected: HTMLElement) {
                            items += `${$(selected).attr('id')},`;
                        });

                        $('#foldersToManage, #itemsToManage').val(items);
                        $('#manageFoldersDialog, #manageItemsDialog').modal('show');

                        const submitButton = $('#manageFoldersDialog .card-header button[value="Manage_Trash"].btn-tool-danger, #manageItemsDialog .card-header button[value="Manage_Trash"].btn-tool-danger');
                        appn.trash.createTrashMessageFromTable(submitButton, selectedItems, T('Items'));
                    }
                });

                appn.dataTable.addSearchPlaceholder();
                const $filter = $('.dataTables_filter');
                const $resetBtn = $(appn.dataTable.FILTER_RESET_BTN);
                $filter.append($resetBtn);
                $resetBtn.on('click', function(e: Event) {
                    e.preventDefault();
                    $filter.find('input').val('');

                    const dataTable = ($('.dataTable') as any).DataTable();
                    dataTable.search('').draw();
                });

                const $table = $('.dataTable');

                $table.on('click', '.edit-btn', function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    enableInlineEdit($(this).closest('tr'));
                });

                $table.on('click', '.save-btn', function(e) {
                    e.preventDefault();
                    e.stopPropagation();

                    const $row = $(this).closest('tr');
                    const id = $row.find('.item-meta').data('id').toString();
                    const isFolder = $row.find('.item-meta').data('is-folder');

                    saveInlineEdit($row, id, isFolder);
                });

                $table.on('click', '.cancel-btn', function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    _dataTable.fnDraw(false);
                });

                $table.on('click', '.trash-btn', function(e) {
                    e.preventDefault();
                    e.stopPropagation();

                    const id = $(this).data('id');
                    const itemName = $(this).closest('tr').find('.dt-titleText').text().trim();

                    $('#itemsToManage').val(id + ',');
                    $('#singleTrashItemName').val(itemName);
                    appn.trash.addTrashMessage($('#hiddenSingleTrashBtn'), '#singleTrashItemName', undefined, undefined, false);
                    $('#hiddenSingleTrashBtn').trigger('click');
                });
            },
            fnDrawCallback: function () {
                setupRowDragging();
                if (_dataTable) {
                    const settings = _dataTable.fnSettings();
                    if (settings) {
                        const wrapper = $(settings.nTableWrapper);
                        const $table = $(settings.nTable);
                        const $emptyState = $('#empty-state');
                        const isSearching = settings.oPreviousSearch.sSearch !== "";
                        const hasNoResults = settings.fnRecordsTotal() === 0;

                        const $scrollContainer = wrapper.find('.dataTables_scroll');
                        const targetElement = $scrollContainer.length ? $scrollContainer : $table;

                        if ($emptyState.parent()[0] !== wrapper[0]) {
                            $emptyState.insertBefore(targetElement);
                        }

                        if (hasNoResults && !isSearching) {
                            $table.addClass('d-none');
                            wrapper.find('.dataTables_scrollHead, .dataTables_scrollBody, .dataTables_length, .dataTables_filter, .dataTables_info, .dataTables_paginate').addClass('d-none');
                            $emptyState.removeClass('d-none');
                        } else {
                            $table.removeClass('d-none');
                            wrapper.find('.dataTables_scrollHead, .dataTables_scrollBody, .dataTables_length, .dataTables_filter, .dataTables_info, .dataTables_paginate').removeClass('d-none');
                            $emptyState.addClass('d-none');

                            setTimeout(() => {
                                _dataTable.fnAdjustColumnSizing(false);
                            }, 10);
                        }
                    }
                }
            }
        });
    }

    function setupRowDragging() {
        if (!_initArgs.canEdit)
            return;

        const $draggables = $('.draggable-row');
        const $dropTargets = $('.drop-target');

        $draggables.off('dragstart.row').on('dragstart.row', function (e: any) {
            e.stopPropagation();
            const $this = $(this);

            let folderIds: string[] = [];
            let docIds: string[] = [];

            // Drag only the single row the user has clicked on
            const id = $this.attr('data-id') || $this.data('id');
            const isFolderStr = String($this.attr('data-is-folder') || $this.data('is-folder')).toLowerCase();
            const isFolder = isFolderStr === 'true';

            if (id) {
                if (isFolder) {
                    folderIds.push(id);
                } else {
                    docIds.push(id);
                }
            }
            $this.addClass('dragging');

            const data = { folderIds: folderIds, docIds: docIds };
            e.originalEvent.dataTransfer.setData('text/plain', JSON.stringify(data));
            e.originalEvent.dataTransfer.effectAllowed = 'move';

            // Prevent visually dragging the entire table
            if (typeof e.originalEvent.dataTransfer.setDragImage === 'function') {
                e.originalEvent.dataTransfer.setDragImage(this, 0, 0);
            }
        });

        $draggables.off('dragend.row').on('dragend.row', function (e: any) {
            e.stopPropagation();
            $('.draggable-row').removeClass('dragging');
        });

        $dropTargets.off('dragover.row').on('dragover.row', function (e: any) {
            // Ignore if the user is dragging files from their OS
            if (e.originalEvent?.dataTransfer?.types?.includes('Files'))
                return;

            e.preventDefault();
            e.stopPropagation();
            const $this = $(this);
            if (!$this.hasClass('dragging')) {
                $this.addClass('drag-over');
            }
            e.originalEvent.dataTransfer.dropEffect = 'move';
        });

        $dropTargets.off('dragleave.row').on('dragleave.row', function (e: any) {
            if (e.originalEvent?.dataTransfer?.types?.includes('Files')) return;
            $(this).removeClass('drag-over');
        });

        $dropTargets.off('drop.row').on('drop.row', function (e: any) {
            if (e.originalEvent?.dataTransfer?.types?.includes('Files')) return;

            e.preventDefault();
            e.stopPropagation();
            const $target = $(this);
            $target.removeClass('drag-over');

            const rawData = e.originalEvent.dataTransfer.getData('text/plain');
            if (!rawData) return;

            let data;
            try {
                data = JSON.parse(rawData);
            } catch (err) {
                return;
            }

            const targetFolderId = $target.attr('data-id') || $target.data('id');

            // Prevent dropping into itself
            if (data.folderIds && data.folderIds.length === 1 && data.folderIds[0] === targetFolderId) return;

            moveItems(data.folderIds || [], data.docIds || [], targetFolderId || '');
        });
    }

    export function moveItems(folderIds: string[], docIds: string[], targetFolderId: string) {
        appn.dialog.showLoading();

        const cleanFolderIds = (folderIds || []).filter(id => id && id.trim() !== '');
        const cleanDocIds = (docIds || []).filter(id => id && id.trim() !== '');

        const payload: any = {
            targetFolderId: targetFolderId || null
        };

        if (cleanFolderIds.length > 0) {
            payload.folderIds = cleanFolderIds.join(',');
        }

        if (cleanDocIds.length > 0) {
            payload.docIds = cleanDocIds.join(',');
        }

        appn.ajax.post({
            url: _initArgs.moveItemUrl,
            data: payload,
            done: function (response: any) {
                const data = typeof response === 'string' ? JSON.parse(response) : response;
                appn.dialog.hideLoading();
                if (data.success) {
                    if (_dataTable) {
                        $(_dataTable.fnSettings().nTableWrapper).removeClass('d-none');
                        _dataTable.fnDraw(false);
                    }
                } else {
                    appn.toast.notify(appn.toast.Type.error, data.message || T('Failed to move items.'));
                }
            },
            fail: function () {
                appn.dialog.hideLoading();
                appn.toast.notify(appn.toast.Type.error, T('An error occurred. Please try again.'));
            }
        });
    }

    function setupDragAndDrop() {
        const $zone = $('.data-table-card-body');
        const $overlay = $('#upload-overlay');
        const $input = $('#global-file-input');
        const $table = $('.dataTable');
        let dragCounter = 0;

        $input.on('change', (e: any) => {
            if (e.target.files && e.target.files.length > 0) {
                uploadFiles(convertFileListToItems(e.target.files));
            }
        });

        const isFileDrag = (e: any) => {
            const types = e.originalEvent.dataTransfer.types;
            if (types) {
                for (let i = 0; i < types.length; i++) {
                    if (types[i] === 'Files') return true;
                }
            }
            return false;
        };

        $zone.on('dragenter', (e: any) => {
            if (isFileDrag(e)) {
                e.preventDefault();
                e.stopPropagation();
                dragCounter++;

                const isEmpty = $('#empty-state').is(':visible') || (_dataTable && _dataTable.fnSettings() && _dataTable.fnSettings().fnRecordsTotal() === 0);

                if (isEmpty) {
                    $('#empty-state').addClass('drag-over');
                } else {
                    $overlay.removeClass('d-none').addClass('active');
                }
            }
        });

        $zone.on('dragover', (e: any) => {
            if (isFileDrag(e)) {
                e.preventDefault();
                e.stopPropagation();
            }
        });

        $zone.on('dragleave', (e: any) => {
            if (isFileDrag(e)) {
                e.preventDefault();
                e.stopPropagation();
                dragCounter--;
                if (dragCounter === 0) {
                    $overlay.addClass('d-none').removeClass('active');
                    $('#empty-state').removeClass('drag-over');
                }
            }
        });

        $table.on('dragover', '.drop-target', function (e: any) {
            if (isFileDrag(e)) {
                e.preventDefault();
                e.stopPropagation();
                $(this).addClass('drag-over');
            }
        });

        $table.on('dragleave', '.drop-target', function (e: any) {
            if (isFileDrag(e)) {
                $(this).removeClass('drag-over');
            }
        });

        const handleDrop = (e: any, targetFolderId?: string) => {
            e.preventDefault();
            e.stopPropagation();
            dragCounter = 0;
            $overlay.addClass('d-none').removeClass('active');
            $('#empty-state').removeClass('drag-over');
            $('.drop-target').removeClass('drag-over');

            const items = e.originalEvent.dataTransfer.items;
            if (items && items.length > 0) {
                const uploadItems: UploadItem[] = [];
                let pending = 0;

                const checkDone = () => {
                    if (pending === 0 && uploadItems.length > 0) {
                        uploadFiles(uploadItems, targetFolderId);
                    }
                };

                for (let i = 0; i < items.length; i++) {
                    const item = items[i];
                    if (item.kind !== 'file') continue;

                    const entry = item.webkitGetAsEntry();
                    if (entry) {
                        pending++;
                        traverseFileTree(entry, '', uploadItems, () => {
                            pending--;
                            checkDone();
                        });
                    }
                }

                if (pending === 0) {
                    const files = e.originalEvent.dataTransfer.files;
                    if (files && files.length > 0) {
                        uploadFiles(convertFileListToItems(files), targetFolderId);
                    }
                }
            } else {
                const files = e.originalEvent.dataTransfer.files;
                if (files && files.length > 0) {
                    uploadFiles(convertFileListToItems(files), targetFolderId);
                }
            }
        };

        $zone.on('drop', (e: any) => {
            if (isFileDrag(e)) {
                handleDrop(e);
            }
        });

        $table.on('drop', '.drop-target', function (e: any) {
            if (isFileDrag(e)) {
                const targetFolderId = $(this).data('id');
                handleDrop(e, targetFolderId);
            }
        });
    }

    function traverseFileTree(item: any, path: string, result: UploadItem[], callback: () => void) {
        path = path || "";
        if (item.isFile) {
            item.file(function (file: File) {
                result.push({ file: file, path: path + file.name });
                callback();
            });
        } else if (item.isDirectory) {
            const dirReader = item.createReader();
            let allEntries: any[] = [];

            const readEntries = () => {
                dirReader.readEntries(function (entries: any[]) {
                    if (entries.length > 0) {
                        allEntries = allEntries.concat(entries);
                        readEntries();
                    } else {
                        if (allEntries.length === 0) {
                            callback();
                        } else {
                            let remaining = allEntries.length;
                            for (let i = 0; i < allEntries.length; i++) {
                                traverseFileTree(allEntries[i], path + item.name + "/", result, () => {
                                    remaining--;
                                    if (remaining === 0) callback();
                                });
                            }
                        }
                    }
                });
            };
            readEntries();
        } else {
            callback();
        }
    }

    function uploadFiles(items: UploadItem[], targetFolderId?: string) {
        if (!items || items.length === 0) return;

        const formData = new FormData();
        for (let i = 0; i < items.length; i++) {
            formData.append('files', items[i].file);
            formData.append('paths', items[i].path);
        }

        const destinationFolderId = targetFolderId || _initArgs.folderId || '';
        const basePath = _initArgs.dataTableUrl.split('?')[0].replace('/DataTable', '');
        const url = `${basePath}/UploadFiles?folderId=${destinationFolderId}`;

        appn.ajax.post({
            url: url,
            data: formData,
            processData: false,
            contentType: false,
            done: function (response: any) {
                const data = typeof response === 'string' ? JSON.parse(response) : response;

                if (data.success) {
                    appn.toast.notify(appn.toast.Type.success,  T('Successfully uploaded {0} item(s).', items.length));
                    if (_dataTable) {
                        $(_dataTable.fnSettings().nTableWrapper).removeClass('d-none');
                        _dataTable.fnDraw(false);
                    }
                } else {
                    appn.toast.notify(appn.toast.Type.error, data.message || T('An unknown error occurred.'));
                }
            },
            fail: function () {
                appn.toast.notify(appn.toast.Type.error, T('An error occurred. Please try again.'));
            }
        });
    }

    function enableInlineEdit($row: JQuery) {
        const isFolder = $row.find('.item-meta').data('is-folder');
        const id = $row.find('.item-meta').data('id').toString();

        // Already editing?
        if ($row.find('input[name="name"]').length) {
            saveInlineEdit($row, id, isFolder);
            return;
        }

        // Disable dragging for this row while editing
        $row.removeClass('draggable-row').attr('draggable', 'false').addClass('editing');

        // Disable all other Edit buttons to prevent editing multiple rows
        $('.dataTable').find('.edit-btn').not($row.find('.edit-btn')).prop('disabled', true);

        // Get current values
        const $nameCell = $row.find('td').eq(1);
        const $descCell = $row.find('td').eq(5);
        const $externalIdCell = $row.find('td').eq(4);
        const name = $nameCell.find('.dt-titleText').text().trim();
        const desc = $descCell.text().trim();
        const externalId = $externalIdCell.text().trim();

        // Store original cell HTML for cancel
        const originalNameCellHtml = $nameCell.html();
        const originalDescCellHtml = $descCell.html();
        const originalExternalIdCellHtml = $externalIdCell.html();
        const originalActionCellHtml = $row.find('td').eq(8).html();

        $nameCell.find('.dt-titleText').html(`<input type='text' class='form-control form-control-sm' name='name' value='${name.replace(/'/g, "\\'")}'>`);
        $nameCell.find('.rowOptions').hide();
        $descCell.html(`<input type='text' class='form-control form-control-sm' name='description' value='${desc.replace(/'/g, "\\'")}'>`);
        $externalIdCell.html(`<input type='text' class='form-control form-control-sm' name='externalid' value='${externalId.replace(/'/g, "\\'")}'>`);

        // Add icon selector for folders only
        if (isFolder) {
            const icon = $row.find('.item-meta').data('icon') || '';
            const $iconImg = $nameCell.find('.img-datatable-icon');

            // Get the row index for unique ID
            const rowIndex = $row.index();
            const selectId = `icon-select-${rowIndex}`;

            appn.ajax.get({
                url: _initArgs.getIconListUrl,
                done: (data: any) => {
                    let options = data.icons.map((i: any) =>
                        `<option value='${i.value}' ${icon === i.value ? 'selected' : ''} data-imagesrc='${i.text}'></option>`
                    ).join('');

                    // Select element with proper structure and unique ID
                    const $iconSelect = $(`
                        <select id='${selectId}' class='form-control form-control-sm d-inline-block' name='icon' style='width: auto; max-width: 70px;'>
                            ${options}
                        </select>
                    `);

                    // Replace the icon image
                    $iconImg.replaceWith($iconSelect);

                    // Initialize the icon selector
                    appn.select.init({
                        selector: `select#${selectId}`,
                        isIconSelect: true
                    });
                }
            });
        }

        const $actionTd = $row.find('td').eq(8);
        $actionTd.children().hide();
        $actionTd.append(`
            <div class='btn-group btn-group-sm inline-edit-actions' role='group'>
                <button class='btn btn-success save-btn'><i class='fa fa-check'></i></button>
                <button class='btn btn-secondary cancel-btn'><i class='fa fa-times'></i></button>
            </div>
        `);

        // Bind events with preventDefault and stopPropagation
        $row.find('.save-btn').off('click').on('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            saveInlineEdit($row, id, isFolder);
        });

        $row.find('.cancel-btn').off('click').on('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            // Restore original cell content
            $nameCell.html(originalNameCellHtml);
            $descCell.html(originalDescCellHtml);
            $externalIdCell.html(originalExternalIdCellHtml);
            $actionTd.html(originalActionCellHtml);

            // Restore row state
            $row.addClass('draggable-row').attr('draggable', 'true').removeClass('editing');

            // Re-enable all Edit buttons
            $('.dataTable').find('.edit-btn').prop('disabled', false);
        });
    }

    function saveInlineEdit($row: JQuery, id: string, isFolder: boolean) {
        const name = $row.find('input[name="name"]').val() as string;
        const description = $row.find('input[name="description"]').val() as string;
        const externalId = $row.find('input[name="externalid"]').val() as string;
        const icon = isFolder ? (($row.find('select[name="icon"]').val() as string) || '') : '';

        if (!name?.trim()) {
            appn.toast.notify(appn.toast.Type.error, T('Name is required'));
            return;
        }

        appn.ajax.post({
            url: _initArgs.inlineUpdateUrl,
            data: { Id: id, IsFolder: isFolder, Name: name, Description: description, Icon: icon, ExternalId: externalId },
            done: (response: any) => {
                const data = typeof response === 'string' ? JSON.parse(response) : response;
                if (data.success) {
                    _dataTable.fnDraw(false);
                } else {
                    appn.toast.notify(appn.toast.Type.error, data.message || T('Failed to save changes to item.'));
                    // Re-enable all Edit buttons on error since we didn't redraw
                    $('.dataTable').find('.edit-btn').prop('disabled', false);
                }
            }
        });
    }
}
